import * as React from 'react';
import { IGenre, EFilter, ICity } from '../../interfaces';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IProps extends WithTranslation{
    genres: IGenre[],
    cities: ICity[],
    years: number[],
    filter: EFilter,
    onChange: any,
    onGenreChange: any,
    onCityChange: any,
    onYearChange: any,
    year?: number,
    currentGenre?: IGenre,
    currentCity?: ICity,
    t: any
}

class FilterBox extends React.Component<IProps, any>{

    render() {
        const {t} = this.props;

        return (
            <div className="filter_box">
                <div className="filter">
                    <button className="change_ganre" type="button">{this.props.currentGenre ? this.props.currentGenre.name : t("Все жарны")} </button>

                    <div className="change_box">
                        <div key={9999} className="radio_box">
                            <input type="radio" id="g" value="" />
                            <label onClick={(event: React.MouseEvent) => {
                                this.props.onGenreChange(null);
                            }} htmlFor="g">{t("Все жарны")}</label>
                        </div>
                        {this.props.genres.map((genre: IGenre, index: number) => {
                            return (<div key={index} className="radio_box">
                                <input type="radio" name="FilterForm[genre_id]" id={"g" + genre.genre_id} value={genre.genre_id} />
                                <label onClick={(event: React.MouseEvent) => {
                                    this.props.onGenreChange(genre.genre_id);
                                }} htmlFor={"g" + genre.genre_id}>{genre.name}</label>
                            </div>);
                        })}
                    </div>
                </div>
                <div className="filter">
                    <button className="change_ganre" type="button">{this.props.currentCity ? this.props.currentCity.name : t("Все страны")} </button>

                    <div className="change_box">
                        <div key={9999} className="radio_box">
                            <input type="radio" id="g" value="" />
                            <label onClick={(event: React.MouseEvent) => {
                                this.props.onCityChange(null);
                            }} htmlFor="g">{t("Все страны")}</label>
                        </div>
                        {this.props.cities.map((city: ICity, index: number) => {
                            return (<div key={index} className="radio_box">
                                <input type="radio" name="FilterForm[city_id]" id={"g" + city.city_id} value={city.city_id} />
                                <label onClick={(event: React.MouseEvent) => {
                                    this.props.onCityChange(city.city_id);
                                }} htmlFor={"g" + city.city_id}>{city.name}</label>
                            </div>);
                        })}
                    </div>
                </div>
                <div className="filter">
                    <button className="change_ganre" type="button">{this.props.year ? this.props.year : t("Все годы")}</button>
                    <div className="change_box">
                        <div key={9999} className="radio_box">
                            <input type="radio" id="g" value="" />
                            <label onClick={(event: React.MouseEvent) => {
                                this.props.onYearChange(null);
                            }} htmlFor="g">{t("Все годы")}</label>
                        </div>
                        {this.props.years.reverse().map((year: number, index: number) => {
                            return (<div key={index} className="radio_box">
                                <input type="radio" name="FilterForm[genre_id]" id={"g" + year} value={year} />
                                <label onClick={(event: React.MouseEvent) => {
                                    this.props.onYearChange(year);
                                }} htmlFor={"g" + year}>{year}</label>
                            </div>);
                        })}
                    </div>
                </div>
                <div className="filter">
                    <button onClick={() => {
                        this.props.onChange(EFilter.NEWEST);
                    }} className={"change_filter "} type="button">
                        {this.props.filter == EFilter.NEWEST ? <b>{t("Новые")}</b> : t("Новые")}
                    </button>
                </div>
                <div className="filter">
                    <button onClick={() => {
                        this.props.onChange(EFilter.POPULAR);
                    }} className={"change_filter " + (this.props.filter == EFilter.POPULAR ? "active" : "")} type="button">
                        {this.props.filter == EFilter.POPULAR ? <b>{t("Популярные")}</b> : t("Популярные")}
                    </button>
                </div>
            </div>
        );
    }
}

export default withTranslation()(FilterBox);